import './input-group.css';
export default {
  "formControl": "pf-c-form-control",
  "inputGroup": "pf-c-input-group",
  "inputGroupText": "pf-c-input-group__text",
  "modifiers": {
    "plain": "pf-m-plain",
    "disabled": "pf-m-disabled"
  },
  "themeDark": "pf-theme-dark"
};